export default __webpack_public_path__ + "static/media/user-icon.0c9853f5.svg";